import React, { useState } from "react";
import PageHero from "../components/PageHero";
import { BRAND } from "../mock/mock";
import { useContent } from "../context/ContentContext";
import { submitContact } from "../services/contentService";
import { Mail, Phone, MapPin, Send } from "lucide-react";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { toast } from "sonner";

export default function Contact() {
  const { brand = BRAND } = useContent();
  const [form, setForm] = useState({ name: "", email: "", phone: "", subject: "", message: "" });
  const [loading, setLoading] = useState(false);

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email || !form.message) {
      toast.error("Lütfen zorunlu alanları doldurunuz.");
      return;
    }
    setLoading(true);
    const res = await submitContact(form);
    setLoading(false);
    if (res.ok) {
      toast.success("Mesajınızı aldık. En kısa sürede dönüş yapacağız.");
      setForm({ name: "", email: "", phone: "", subject: "", message: "" });
    } else {
      toast.error(res.error || "Gönderim başarısız. Lütfen tekrar deneyin.");
    }
  };

  return (
    <>
      <PageHero
        kicker="BİZE ULAŞIN"
        title="Bir sonraki adımınız için konuşalım."
        subtitle="Sorularınız, projeleriniz veya işbirliği talebiniz için formu doldurun; ekibimiz size en kısa sürede dönüş yapsın."
      />
      <section className="py-20 lg:py-28 bg-[#0a0a0a]">
        <div className="max-w-[1200px] mx-auto px-6 lg:px-10 grid lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5 space-y-6">
            <div className="border border-[#B87333]/20 bg-[#0d0b09] p-8">
              <h3 className="text-[11px] tracking-[0.3em] text-[#B87333] mb-6">İLETİŞİM BİLGİLERİ</h3>
              <ul className="space-y-6">
                <li className="flex items-start gap-4">
                  <div className="w-11 h-11 border border-[#B87333]/30 flex items-center justify-center">
                    <MapPin className="w-4 h-4 text-[#B87333]" />
                  </div>
                  <div>
                    <p className="text-[10px] tracking-[0.3em] text-[#a89a85]">ADRES</p>
                    <p className="text-[#f5ede1] mt-1 leading-relaxed">{brand.address}</p>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-11 h-11 border border-[#B87333]/30 flex items-center justify-center">
                    <Phone className="w-4 h-4 text-[#B87333]" />
                  </div>
                  <div>
                    <p className="text-[10px] tracking-[0.3em] text-[#a89a85]">TELEFON</p>
                    <a href={`tel:${brand.phoneRaw}`} className="text-[#f5ede1] mt-1 block hover:text-[#B87333]">{brand.phone}</a>
                  </div>
                </li>
                <li className="flex items-start gap-4">
                  <div className="w-11 h-11 border border-[#B87333]/30 flex items-center justify-center">
                    <Mail className="w-4 h-4 text-[#B87333]" />
                  </div>
                  <div>
                    <p className="text-[10px] tracking-[0.3em] text-[#a89a85]">E-POSTA</p>
                    <a href={`mailto:${brand.email}`} className="text-[#f5ede1] mt-1 block hover:text-[#B87333]">{brand.email}</a>
                  </div>
                </li>
              </ul>
            </div>
            <div className="aspect-[4/3] border border-[#B87333]/20 overflow-hidden">
              <iframe
                title="Harita"
                className="w-full h-full grayscale contrast-125 opacity-90"
                src="https://www.openstreetmap.org/export/embed.html?bbox=28.975%2C41.065%2C29.025%2C41.085&layer=mapnik"
              />
            </div>
          </div>
          <form onSubmit={onSubmit} className="lg:col-span-7 border border-[#B87333]/20 bg-[#0d0b09] p-8 lg:p-10 space-y-6">
            <h3 className="font-serif-display text-[#f5ede1] text-3xl">Bize yazın</h3>
            <div className="grid md:grid-cols-2 gap-5">
              <div>
                <Label htmlFor="name" className="text-[11px] tracking-[0.3em] text-[#a89a85]">AD SOYAD *</Label>
                <Input id="name" name="name" value={form.name} onChange={onChange}
                  className="mt-2 bg-transparent border-0 border-b border-[#B87333]/30 rounded-none focus-visible:ring-0 focus-visible:border-[#B87333] text-[#f5ede1]" />
              </div>
              <div>
                <Label htmlFor="email" className="text-[11px] tracking-[0.3em] text-[#a89a85]">E-POSTA *</Label>
                <Input id="email" type="email" name="email" value={form.email} onChange={onChange}
                  className="mt-2 bg-transparent border-0 border-b border-[#B87333]/30 rounded-none focus-visible:ring-0 focus-visible:border-[#B87333] text-[#f5ede1]" />
              </div>
              <div>
                <Label htmlFor="phone" className="text-[11px] tracking-[0.3em] text-[#a89a85]">TELEFON</Label>
                <Input id="phone" name="phone" value={form.phone} onChange={onChange}
                  className="mt-2 bg-transparent border-0 border-b border-[#B87333]/30 rounded-none focus-visible:ring-0 focus-visible:border-[#B87333] text-[#f5ede1]" />
              </div>
              <div>
                <Label htmlFor="subject" className="text-[11px] tracking-[0.3em] text-[#a89a85]">KONU</Label>
                <Input id="subject" name="subject" value={form.subject} onChange={onChange}
                  className="mt-2 bg-transparent border-0 border-b border-[#B87333]/30 rounded-none focus-visible:ring-0 focus-visible:border-[#B87333] text-[#f5ede1]" />
              </div>
            </div>
            <div>
              <Label htmlFor="message" className="text-[11px] tracking-[0.3em] text-[#a89a85]">MESAJINIZ *</Label>
              <Textarea id="message" name="message" rows={6} value={form.message} onChange={onChange}
                className="mt-2 bg-transparent border border-[#B87333]/30 rounded-none focus-visible:ring-0 focus-visible:border-[#B87333] text-[#f5ede1] resize-none" />
            </div>
            <button
              type="submit"
              disabled={loading}
              className="group inline-flex items-center gap-3 px-10 py-4 bg-[#B87333] text-[#0a0a0a] text-[11px] tracking-[0.3em] font-semibold hover:bg-[#D4A574] transition-colors disabled:opacity-60"
            >
              {loading ? "GÖNDERİLİYOR…" : "GÖNDER"} <Send className="w-4 h-4" />
            </button>
          </form>
        </div>
      </section>
    </>
  );
}
